<template>
  <authorization permissionKey="configuration_facilitator_hpp" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Facilitadores de História da Patologia Pregressa
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs v-model="tab" background-color="transparent" color="secondary">
            <v-tab v-for="(value, key) in facilitatorTypes" :key="key">
              {{ value }}
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="(value, key) in facilitatorTypes" :key="key">
              <HPPList
                :facilitators="historyPathologyFacilitators"
                :facilitatorType="key"
                :refreshList="refreshList"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
  </authorization>
</template>

<script>
  import HPPList from "@/components/config/hpp/list/index.vue";

  export default {
    name: "HFConfig",
    components: {
      HPPList,
    },
    data() {
      return {
        tab: null,
        facilitatorTypes: {
          introduction: "Introdução",
          pathology: "Patologia",
          procedure: "Procedimento",
          site: "Local",
          period: "Tempo",
        },
      };
    },
    apollo: {
      historyPathologyFacilitators: {
        query: require("@/graphql/history_pathology_facilitators.gql"),
        pollInterval: 20000,
      },
    },
    methods: {
      refreshList() {
        this.$apollo.queries.historyPathologyFacilitators.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
